import { Factory, Wrench, FlaskConical, Boxes } from "lucide-react";

// Páginas por setor — conteúdo otimizado para pesquisas em Portugal.
export const SECTORS = [
  {
    slug: "industria",
    icon: Factory,
    name: "Indústria",
    hero: "Impressão 3D para a Indústria em Portugal",
    metaTitle: "Impressão 3D Industrial em Portugal | AxioForm 3D",
    metaDescription:
      "Fabrico aditivo para a indústria em Portugal: ferramentas de linha, gabaritos, peças funcionais e produção de pequenas séries em FDM, SLA e SLS. Orçamento em menos de 2h.",
    intro:
      "Apoiamos empresas industriais portuguesas na prototipagem e produção de peças funcionais e ferramentas de apoio à produção. Do gabarito de montagem à pequena série de peças finais, produzimos com controlo dimensional e o material adequado a cada aplicação.",
    applications: [
      "Gabaritos e ferramentas de linha de produção (jigs & fixtures)",
      "Peças funcionais e componentes de máquinas",
      "Pequenas séries de produção sob medida",
      "Substituição de peças descontinuadas",
    ],
    materials: ["PETG-CF (fibra de carbono)", "Nylon SLS PA12", "ABS", "PETG"],
    kicker: "Reduza paragens de linha e custos de ferramenta com fabrico aditivo local.",
  },
  {
    slug: "manutencao",
    icon: Wrench,
    name: "Manutenção Industrial",
    hero: "Peças de Reposição por Impressão 3D",
    metaTitle: "Peças de Reposição 3D para Manutenção Industrial | AxioForm 3D",
    metaDescription:
      "Reposição rápida de peças por impressão 3D em Portugal. Componentes descontinuados, sobresselentes e peças de desgaste fabricados a partir do seu modelo ou amostra.",
    intro:
      "Quando uma peça falha e o fornecedor original já não a produz, a impressão 3D é a via mais rápida para voltar a produzir. Reproduzimos componentes a partir do seu ficheiro CAD, desenho técnico ou amostra, com envio expresso para todo o país.",
    applications: [
      "Peças descontinuadas e sobresselentes",
      "Componentes de desgaste e casquilhos",
      "Suportes, tampas e proteções",
      "Adaptadores e peças de ligação",
    ],
    materials: ["PETG", "PETG-CF", "Nylon SLS", "TPU (flexível)"],
    kicker: "Sem peça em stock? Enviamos-lhe uma proposta e reposição em dias, não semanas.",
  },
  {
    slug: "laboratorios",
    icon: FlaskConical,
    name: "Laboratórios & Investigação",
    hero: "Impressão 3D para Laboratórios e I&D",
    metaTitle: "Impressão 3D para Laboratórios e Investigação em Portugal | AxioForm 3D",
    metaDescription:
      "Peças personalizadas para laboratórios e centros de investigação em Portugal: suportes de sensores, housings, adaptadores e material de ensaio em impressão 3D de precisão.",
    intro:
      "Trabalhamos com laboratórios, universidades e equipas de I&D para produzir material personalizado que não existe no mercado: suportes, adaptadores e caixas para eletrónica e sensores, com detalhe e precisão dimensional.",
    applications: [
      "Housings e caixas para eletrónica e sensores",
      "Suportes e fixações personalizadas",
      "Adaptadores e peças de bancada de ensaios",
      "Modelos e protótipos para investigação",
    ],
    materials: ["Resina Tough", "PLA técnico", "PETG", "Nylon SLS"],
    kicker: "Da ideia ao protótipo funcional, com confidencialidade garantida.",
  },
  {
    slug: "makers",
    icon: Boxes,
    name: "Makers & Particulares",
    hero: "Impressão 3D para Makers e Particulares",
    metaTitle: "Impressão 3D para Makers e Particulares em Portugal | AxioForm 3D",
    metaDescription:
      "Tem um modelo 3D e precisa de o imprimir? Serviço de impressão 3D para makers e particulares em Portugal. Envie o ficheiro STL e receba orçamento rápido.",
    intro:
      "Tem uma peça específica que quer produzir? Ajudamos makers e particulares a dar vida aos seus projetos, com aconselhamento de material e acabamento. Basta enviar o ficheiro e nós tratamos do resto.",
    applications: [
      "Peças únicas e projetos pessoais",
      "Componentes para modelismo e hobby",
      "Peças de substituição para casa",
      "Presentes e objetos personalizados",
    ],
    materials: ["PLA", "PETG", "TPU (flexível)", "Resina"],
    kicker: "Uma peça só? Sem problema. Avaliação caso a caso, sem compromisso.",
  },
];

export const getSector = (slug) => SECTORS.find((s) => s.slug === slug);
